import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMeasure } from '../performance';
export var ANALYTICS_CHANNEL = 'media';
export var context = {
  componentName: 'smart-cards',
  packageName: "@atlaskit/smart-card",
  packageVersion: "32.8.3"
};
export var TrackQuickActionType = /*#__PURE__*/function (TrackQuickActionType) {
  TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
  return TrackQuickActionType;
}({});
export var TrackQuickActionFailureReason = /*#__PURE__*/function (TrackQuickActionFailureReason) {
  TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
  TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
  TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
  return TrackQuickActionFailureReason;
}({});
var uiActionSubjectIds = {
  DownloadAction: 'downloadDocument',
  PreviewAction: 'invokePreviewScreen',
  ViewAction: 'shortcutGoToLink',
  StatusAction: 'issueStatusUpdate'
};
export var SmartLinkEvents = /*#__PURE__*/function () {
  function SmartLinkEvents() {
    _classCallCheck(this, SmartLinkEvents);
  }
  return _createClass(SmartLinkEvents, [{
    key: "insertSmartLink",
    value: function insertSmartLink(url, type, createAnalyticsEvent) {
      fireSmartLinkEvent({
        action: 'inserted',
        actionSubject: 'smartLink',
        eventType: 'track',
        attributes: {
          type: type
        },
        nonPrivacySafeAttributes: {
          domainName: url
        }
      }, createAnalyticsEvent);
    }
  }]);
}();
export var fireSmartLinkEvent = function fireSmartLinkEvent(payload, createAnalyticsEvent) {
  if (createAnalyticsEvent) {
    createAnalyticsEvent(payload).fire(ANALYTICS_CHANNEL);
  }
};
export var invokeSucceededEvent = function invokeSucceededEvent(_ref) {
  var id = _ref.id,
    actionType = _ref.actionType,
    display = _ref.display,
    extensionKey = _ref.extensionKey,
    definitionId = _ref.definitionId,
    destinationProduct = _ref.destinationProduct,
    destinationSubproduct = _ref.destinationSubproduct,
    location = _ref.location;
  var measure = id ? getMeasure(id, 'resolved') : undefined;
  return {
    action: 'resolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      actionType: actionType,
      display: display,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      extensionKey: extensionKey,
      duration: measure === null || measure === void 0 ? void 0 : measure.duration
    })
  };
};
export var invokeFailedEvent = function invokeFailedEvent(_ref2) {
  var id = _ref2.id,
    actionType = _ref2.actionType,
    display = _ref2.display,
    reason = _ref2.reason,
    extensionKey = _ref2.extensionKey,
    definitionId = _ref2.definitionId,
    destinationProduct = _ref2.destinationProduct,
    destinationSubproduct = _ref2.destinationSubproduct,
    location = _ref2.location;
  var measure = id ? getMeasure(id, 'errored') : undefined;
  return {
    action: 'unresolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      actionType: actionType,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      duration: measure === null || measure === void 0 ? void 0 : measure.duration,
      reason: reason
    })
  };
};
export var uiActionClickedEvent = function uiActionClickedEvent(_ref3) {
  var id = _ref3.id,
    actionType = _ref3.actionType,
    extensionKey = _ref3.extensionKey,
    display = _ref3.display,
    definitionId = _ref3.definitionId,
    destinationProduct = _ref3.destinationProduct,
    destinationSubproduct = _ref3.destinationSubproduct,
    location = _ref3.location;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: uiActionSubjectIds[actionType],
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      display: display,
      actionType: actionType,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiRenderSuccessEvent = function uiRenderSuccessEvent(_ref4) {
  var display = _ref4.display,
    status = _ref4.status,
    extensionKey = _ref4.extensionKey,
    definitionId = _ref4.definitionId,
    destinationProduct = _ref4.destinationProduct,
    destinationSubproduct = _ref4.destinationSubproduct,
    location = _ref4.location,
    canBeDatasource = _ref4.canBeDatasource;
  return {
    action: 'renderSuccess',
    actionSubject: 'smartLink',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      status: status,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display,
      canBeDatasource: canBeDatasource
    })
  };
};
export var uiRenderFailedEvent = function uiRenderFailedEvent(_ref5) {
  var display = _ref5.display,
    error = _ref5.error,
    errorInfo = _ref5.errorInfo,
    extensionKey = _ref5.extensionKey,
    definitionId = _ref5.definitionId,
    destinationProduct = _ref5.destinationProduct,
    destinationSubproduct = _ref5.destinationSubproduct,
    location = _ref5.location;
  return {
    actionSubject: 'smartLink',
    action: 'renderFailed',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      error: error,
      errorInfo: errorInfo,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};